(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["az-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('az-carousel')) {
  class AzCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-az-track]');
      if (!this.track) return;

      this.prev = this.querySelector('[data-az-prev]');
      this.next = this.querySelector('[data-az-next]');
      this.thumb = this.querySelector('[data-az-progress]');
      this.update = this.update.bind(this);

      this.track.addEventListener('scroll', this.update, { passive: true });
      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));

      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.update);
      if (this.observer) this.observer.disconnect();
    }

    go(direction) {
      const item = this.track.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * step, behavior: smooth ? 'smooth' : 'auto' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = Math.abs(this.track.scrollLeft);

      this.toggleAttribute('data-sin-scroll', max <= 2);
      if (this.prev) this.prev.disabled = x <= 2;
      if (this.next) this.next.disabled = x >= max - 2;

      if (this.thumb && max > 0) {
        const visible = this.track.clientWidth / this.track.scrollWidth;
        this.thumb.style.width = `${visible * 100}%`;
        this.thumb.style.transform = `translateX(${(x / max) * (1 / visible - 1) * 100}%)`;
      }
    }
  }

  customElements.define('az-carousel', AzCarousel);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["az-ritual-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('az-ritual-upsell')) {
  class AzRitualUpsell extends HTMLElement {
    connectedCallback() {
      this.onChange = (event) => {
        const input = event.target;
        if (input && input.name === 'id') this.show(input.value);
      };
      document.addEventListener('change', this.onChange);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event.data && event.data.variant;
          if (variant) this.show(variant.id);
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
      if (this.unsubscribe) this.unsubscribe();
    }

    show(id) {
      const items = this.querySelectorAll('[data-variant]');
      const match = Array.from(items).some((item) => item.dataset.variant === String(id));
      if (!match) return;
      items.forEach((item) => {
        item.hidden = item.dataset.variant !== String(id);
      });
    }
  }

  customElements.define('az-ritual-upsell', AzRitualUpsell);
}
  } catch(e) { console.error(e); }
})();

})();
